import { Alert, Badge, Button } from "react-bootstrap";

//import { DateTime } from 'luxon';
//import { messages, ticket } from './SupportComponent';
import { Redirect } from "react-router";

import ReplyTicketFormComponent from "./ReplyTicketFormComponent";

const TicketComponent = (_props: any) => {
  const username = "John Doe";

  const ticketData = {
    id: "001",
    category: "Question technique",
    title: "Erreur lors du changement de mon nom",
    openedOn: new Date().toDateString(),
    updatedOn: new Date().toDateString(),
    state: "Traité",
    author: "John Doe",
    messages: [
      {
        content:
          "Bonjour, je viens à vous suite à un problème[...]. En ésperant que vous trouverez une solution,\nCordialement,\nJohn DOE",
        date: new Date().toDateString(),
        author: "John Doe",
        files: ["fichier_joint.pdf"],
      },
      {
        content:
          "Bonjour, je remonte l'e problème à notre service dévellopement, je vous tiendrais au courant dans les plus brefs délais,\nCordialement,\nAssistant Dwell",
        date: new Date().toDateString(),
        author: "Assistant Dwell",
        files: [],
      },
      {
        content:
          "Bonjour, nos équipes ont localisé le problème et le résoudrons dans les plus bref délais.\nCordialement,\nAssistant Dwell",
        date: new Date().toDateString(),
        author: "Assistant Dwell",
        files: [],
      },
      {
        content:
          "Bonjour, tout devrais fonctionner normalement, tenez moi au courant.\nCordialement,\nAssistant Dwell",
        date: new Date().toDateString(),
        author: "Assistant Dwell",
        files: [],
      },
      {
        content: "C'est bon, Merci beaucoup.",
        date: new Date().toDateString(),
        author: "John Doe",
        files: [],
      },
    ],
  };

  if (ticketData.author !== username) return <Redirect to="/" />;

  return (
    <div className="mx-3 mt-5">
      <div className="d-flex flex-row justify-content-between">
        <h1 className="mb-2">Ticket #{ticketData.id}</h1>
        <Button variant="outline-primary pt-3" href="/support">
          <i className="bi bi-arrow-return-left"></i>
        </Button>
      </div>
      <h2 className="title-h2">
        Retrouvez toutes les informations concernant votre demande d'assistance
      </h2>

      <div className="d-flex flew-row justify-content-start flew-wrap gap-2">
        <p>
          <strong>Sujet: </strong>
        </p>
        <p>{ticketData.title}</p>
        {ticketData.state === "Traité" ? (
          <p>
            <Badge bg="success">Traité</Badge>
          </p>
        ) : (
          <p>
            <Badge bg="primary">En cours</Badge>
          </p>
        )}
      </div>
      <div className="d-flex flew-row justify-content-start flew-wrap gap-2">
        <p>
          <strong>Catégorie: </strong>
        </p>
        <p>{ticketData.category}</p>
      </div>
      <div className="d-flex flew-row justify-content-start flew-wrap gap-2 mb-2">
        <strong>Créer le :</strong> {ticketData.openedOn}
      </div>
      <div className="d-flex flew-row justify-content-start flew-wrap gap-2 mb-2">
        <strong>Dernière modification effectuer le :</strong>{" "}
        {ticketData.updatedOn}
      </div>

      <div className="mt-2">
        {ticketData.messages.map((value, index) => {
          return (
            <div
              key={index}
              className={
                value.author === username
                  ? "mb-3 ms-5 ml-5 d-flex flex-column justify-content-end"
                  : "mb-3 text-dark me-5 mr-5 d-flex flex-column justify-content-start"
              }
            >
              <div
                className={
                  value.author === username
                    ? "ms-5 ml-5 bg-container text-end"
                    : "me-5 mr-5 bg-answer"
                }
              >
                <h4>{value.author === username ? "Vous" : value.author} :</h4>
                <p style={{ whiteSpace: "pre-line" }}>{value.content}</p>
                <p
                  className={
                    value.author === username ? "text-start" : "text-end"
                  }
                >
                  <strong> recu le </strong> {value.date}
                </p>
                {value.files.map((file) => {
                  return (
                    <a key={file} href={file} target="_blank" rel="noreferrer">
                      {file}
                    </a>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <hr className="text-muted" />
      {ticketData.state === "Traité" ? (
        <Alert variant="primary" className="w-75 mx-auto">
          Ce ticket (#{ticketData.id}) à été marqué comme traité. Vous ne pouvez
          plus répondre à ce fil de discussion.
        </Alert>
      ) : (
        <ReplyTicketFormComponent ticketID={ticketData.id} />
      )}
    </div>
  );
};
export default TicketComponent;
